export enum UserType {
  Parent = 'Parent',
  Teacher = 'Teacher',
  SchoolAdmin = 'School Admin',
  DistrictAdmin = 'District Admin',
  Student = 'Student',
  Player = 'SW Player'
}
